module.exports = __webpack_public_path__ + "assets/diqiuyi.b3428f54.svg";